import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { NavigationItem } from '../../../navigation/types';

export interface NavigationProps {
  items: NavigationItem[];
  collapsed?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({ items, collapsed = false }) => {
  const location = useLocation();

  return (
    <ul role="list" className="-mx-2 space-y-1">
      {items.map((item) => {
        const isActive = location.pathname === item.href;
        return (
          <li key={item.name}>
            <Link
              to={item.href}
              className={classNames(
                isActive
                  ? 'link-active bg-gray-50 text-indigo-600'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600',
                'group flex items-center',
                collapsed ? 'justify-center p-2' : 'gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
              )}
            >
              <item.icon
                aria-hidden={true}
                className={classNames(
                  isActive ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600',
                  'size-6 shrink-0',
                  collapsed ? 'mx-auto' : ''
                )}
              />
              {!collapsed && item.name}
            </Link>
            {item.children && item.children.length > 0 && (
              <div className={collapsed ? '' : 'ml-4'}>
                <Navigation items={item.children} collapsed={collapsed} />
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};

function classNames(...classes: (string | undefined | false)[]): string {
  return classes.filter(Boolean).join(' ');
}